module.exports = __webpack_public_path__ + "static/media/GLO.32f4562d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/GLO.svg
// module id = 380
// module chunks = 25